'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _Locale = require('../../../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _reactIntl = require('react-intl');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ClickTracker = require('../../../services/ClickTracker');

var _reactRedux = require('react-redux');

var _ModuleReducer = require('../../../components/module/ModuleReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePicker = function (_React$Component) {
  (0, _inherits3.default)(DatePicker, _React$Component);

  function DatePicker(props) {
    (0, _classCallCheck3.default)(this, DatePicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call(this, props));

    _this.handleChange = function (date) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());

      if (date && (typeof date === 'undefined' ? 'undefined' : (0, _typeof3.default)(date)) === "object") {
        _this.props.onChange(date.toISOString().split('.')[0] + 'Z');
      } else {
        _this.props.onChange(null);
      }
    };

    _this.getWeekDays = function () {
      var sunday = (0, _moment2.default)('2016-05-01');
      var monday = (0, _moment2.default)('2016-05-02');
      var tuesday = (0, _moment2.default)('2016-05-03');
      var wednesday = (0, _moment2.default)('2016-05-04');
      var thursday = (0, _moment2.default)('2016-05-05');
      var friday = (0, _moment2.default)('2016-05-06');
      var saturday = (0, _moment2.default)('2016-05-07');

      return [_this.formatWeekDay(sunday), _this.formatWeekDay(monday), _this.formatWeekDay(tuesday), _this.formatWeekDay(wednesday), _this.formatWeekDay(thursday), _this.formatWeekDay(friday), _this.formatWeekDay(saturday)];
    };

    _this.formatWeekDay = function (day) {
      var formatDate = _this.props.intl.formatDate;

      return formatDate(day, { weekday: 'short' }).substring(0, 1);
    };

    _this.getMonths = function () {
      var january = (0, _moment2.default)('2016-01-01');
      var february = (0, _moment2.default)('2016-02-01');
      var march = (0, _moment2.default)('2016-03-01');
      var april = (0, _moment2.default)('2016-04-01');
      var may = (0, _moment2.default)('2016-05-01');
      var june = (0, _moment2.default)('2016-06-01');
      var july = (0, _moment2.default)('2016-07-01');
      var august = (0, _moment2.default)('2016-08-01');
      var september = (0, _moment2.default)('2016-09-01');
      var october = (0, _moment2.default)('2016-10-01');
      var november = (0, _moment2.default)('2016-11-01');
      var december = (0, _moment2.default)('2016-12-01');

      return [_this.formatMonth(january), _this.formatMonth(february), _this.formatMonth(march), _this.formatMonth(april), _this.formatMonth(may), _this.formatMonth(june), _this.formatMonth(july), _this.formatMonth(august), _this.formatMonth(september), _this.formatMonth(october), _this.formatMonth(november), _this.formatMonth(december)];
    };

    _this.formatMonth = function (month) {
      var formatDate = _this.props.intl.formatDate;

      return formatDate(month, { month: 'long' });
    };

    _this.formatValue = function () {
      if ((0, _typeof3.default)(_this.props.value) === "object") {
        return _this.props.value;
      } else if (_this.props.value === undefined) {
        return null;
      } else {
        var hasTime = _this.props.value ? _this.props.value.split('T').length > 1 : false;
        var newDate = hasTime ? (0, _moment2.default)(_this.props.value) : (0, _moment2.default)(_this.props.value + 'T00:00:00Z');

        if (!newDate.isValid()) {
          return null;
        } else {
          return newDate;
        }
      }
    };

    _this.formatDate = function (date) {
      var formatDate = _this.props.intl.formatDate;

      var weekday = _this.props.weekdayFormat ? _this.props.weekdayFormat : 'short';
      var month = _this.props.monthFormat ? _this.props.monthFormat : 'numeric';
      var year = _this.props.yearFormat ? _this.props.yearFormat : 'numeric';
      var day = _this.props.dayFormat ? _this.props.dayFormat : 'numeric';
      return formatDate(date, { weekday: weekday, month: month, year: year, day: day });
    };

    _this.getAutomationName = function () {
      return _AutomationName2.default.get('date', _this.props.automationName);
    };

    _moment2.default.locale(_this.props.locale);
    return _this;
  }

  (0, _createClass3.default)(DatePicker, [{
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;

      var daysOfWeek = this.getWeekDays();
      var monthNames = this.getMonths();

      return _react2.default.createElement(_cwUi.CwDatePicker, (0, _assign2.default)({}, this.props, {
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined,
        daysOfTheWeek: daysOfWeek,
        monthName: monthNames,
        value: this.formatValue(),
        formatter: this.formatDate,
        localToday: formatMessage(_Locale2.default.today)
      }));
    }
  }]);
  return DatePicker;
}(_react2.default.Component);

DatePicker.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwDatePicker.propTypes, {
  /**
  * Date to be shown in the DatePicker
  */
  value: _propTypes2.default.string,
  /**
   * Arguments to format weekday, accepts all arguments for Intl.DateTimeFormat.
   * If not set will default to short. Possible values are "narrow", "short", "long".
   * To explicitly hide set to null. 
   */
  weekdayFormat: _propTypes2.default.string,
  /**
   * Arguments to format month, accepts all arguments for Intl.DateTimeFormat.
   * If not set will default to numeric.  Possible values are "numeric", "2-digit", "narrow", "short", "long".
   * To explicitly hide set to null. 
   */
  monthFormat: _propTypes2.default.string,
  /**
   * Arguments to format year, accepts all arguments for Intl.DateTimeFormat.
   * If not set will default to numeric. Possible values are "numeric", "2-digit"
   * To explicitly hide set to null. 
   */
  yearFormat: _propTypes2.default.string,
  /**
   * Arguments to format day, accepts all arguments for Intl.DateTimeFormat.
   * If not set will default to numeric. Possible values are "numeric", "2-digit".
   * To explicitly hide set to null. 
   */
  dayFormat: _propTypes2.default.string,
  /**
    * Override required prop from spread, these props should never
    * be set when using the date field as they are set in this 
    * component above
    */
  formatter: _propTypes2.default.func
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: (0, _ModuleReducer.getLocale)(state.module)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)(DatePicker));


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/datepicker/DatePicker.js
// module id = 770
// module chunks = 10